import {Divider} from "@material-ui/core";

const ContentDividerCommon = () => (
  <Divider light style={{marginTop: '16px', marginBottom: '16px'}}/>
);

export default ContentDividerCommon;